import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { store } from './store/store';

import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';

// Public Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import About from './pages/About';
import Contact from './pages/Contact';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

// Legal Pages
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import RefundPolicy from './pages/RefundPolicy';
import FAQ from './pages/FAQ';

// Investor Pages
import InvestorDashboard from './pages/Investor/InvestorDashboard';
import InvestmentPlans from './pages/Investor/InvestmentPlans';
import MyInvestments from './pages/Investor/MyInvestments';
import Wallet from './pages/Investor/Wallet';
import ProfitTracker from './pages/Investor/ProfitTracker';
import InvestmentPayment from './pages/Investor/InvestmentPayment';
import WithdrawMoney from './pages/Investor/WithdrawMoney';
import KYCPage from './pages/Investor/KYCPage';
import MyTeam from './pages/Investor/MyTeam';  // ✅ NEW
import UserBonus from './pages/Investor/UserBonus'; // ✅ NEW

// Admin Pages
import AdminDashboard from './pages/Admin/AdminDashboard';
import AdminInvestments from './pages/Admin/AdminInvestments';
import AdminUsers from './pages/Admin/AdminUsers';
import AdminWalletTransactions from './pages/Admin/AdminWalletTransactions';
import AdminWithdrawals from './pages/Admin/AdminWithdrawals';
import AdminKYC from './pages/Admin/AdminKYC';
import AdminReferrals from './pages/Admin/AdminReferrals';  // ✅ NEW
import AdminBonus from './pages/Admin/AdminBonus'; // ✅ NEW

// Auth Pages
import GoogleCallback from './pages/Auth/GoogleCallback';

// Protected Routes
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';

function App() {
  return (
    <Provider store={store}>
      <HelmetProvider>
        <Router>
          <div className="min-h-screen flex flex-col bg-gray-50">
            <Navbar />
            <main className="flex-grow pt-24">
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                
                {/* Legal Routes */}
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsAndConditions />} />
                <Route path="/refund-policy" element={<RefundPolicy />} />
                <Route path="/faq" element={<FAQ />} />
                
                {/* Google Auth */}
                <Route path="/auth/google/success" element={<GoogleCallback />} />
                
                {/* Investor Routes */}
                <Route path="/investor/dashboard" element={<ProtectedRoute><InvestorDashboard /></ProtectedRoute>} />
                <Route path="/investor/plans" element={<ProtectedRoute><InvestmentPlans /></ProtectedRoute>} />
                <Route path="/investor/my-investments" element={<ProtectedRoute><MyInvestments /></ProtectedRoute>} />
                <Route path="/investor/wallet" element={<ProtectedRoute><Wallet /></ProtectedRoute>} />
                <Route path="/investor/profit-tracker" element={<ProtectedRoute><ProfitTracker /></ProtectedRoute>} />
                <Route path="/investor/payment" element={<ProtectedRoute><InvestmentPayment /></ProtectedRoute>} />
                <Route path="/investor/withdraw" element={<ProtectedRoute><WithdrawMoney /></ProtectedRoute>} />
                <Route path="/investor/kyc" element={<ProtectedRoute><KYCPage /></ProtectedRoute>} />
                <Route path="/investor/my-team" element={<ProtectedRoute><MyTeam /></ProtectedRoute>} />  {/* ✅ NEW */}
                <Route path="/investor/bonus" element={<ProtectedRoute><UserBonus /></ProtectedRoute>} />  {/* ✅ NEW */}
                
                {/* Admin Routes */}
                <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
                <Route path="/admin/investments" element={<AdminRoute><AdminInvestments /></AdminRoute>} />
                <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
                <Route path="/admin/wallet-transactions" element={<AdminRoute><AdminWalletTransactions /></AdminRoute>} />
                <Route path="/admin/withdrawals" element={<AdminRoute><AdminWithdrawals /></AdminRoute>} />
                <Route path="/admin/kyc" element={<AdminRoute><AdminKYC /></AdminRoute>} />
                <Route path="/admin/referrals" element={<AdminRoute><AdminReferrals /></AdminRoute>} />  {/* ✅ NEW */}
                <Route path="/admin/bonuses" element={<AdminRoute><AdminBonus /></AdminRoute>} />  {/* ✅ NEW */}
                
                {/* Default */}
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </main>
            <Footer />
            <Toaster 
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: { background: '#363636', color: '#fff' },
                success: { duration: 3000, iconTheme: { primary: '#22c55e', secondary: '#fff' } },
                error: { duration: 4000, iconTheme: { primary: '#ef4444', secondary: '#fff' } },
              }}
            />
          </div>
        </Router>
      </HelmetProvider>
    </Provider>
  );
}

export default App;